const MEDIA_STORAGE_BASE_URL = 'https://rieltor-images.lunstatic.net/rieltor-ua-01';
const MEDIA_STORAGE_ORIGINAL_BASE_URL = `${MEDIA_STORAGE_BASE_URL}/origin`;
const LUN_MEDIA_STORAGE_ORIGINAL_BASE_URL = 'https://market-images.lunstatic.net/lun-ua/origin';
const fallBackPrefix = 'images/';
// This module must not create a Redux store: store creation starts all root sagas.
let configuredMediaStorageBaseUrl = MEDIA_STORAGE_BASE_URL;

export const setMediaStorageBaseUrl = (url?: string) => {
  configuredMediaStorageBaseUrl = url || MEDIA_STORAGE_BASE_URL;
};

const createMediaStorageAbsoluteUrl = (baseurl: string, path: string) =>
    `${baseurl}${path}`;
export const createResizedImageUrl = (
    imageKey: string,
    width: number,
    height: number) => {
  let baseUrl = configuredMediaStorageBaseUrl;
  if (imageKey.indexOf(fallBackPrefix) == -1) {
    baseUrl = MEDIA_STORAGE_BASE_URL;
  }
  return createMediaStorageAbsoluteUrl(baseUrl, `/${width}/${height}/${imageKey}`);
};

export const createSrcSet = (...urls: string[]) =>
    urls.map((url, index) => `${url} ${index + 1}x`).join(', ');

export const createOriginalImageUrl = (imageKey: string) =>
  createMediaStorageAbsoluteUrl(
    imageKey.indexOf(fallBackPrefix) === 0
      ? LUN_MEDIA_STORAGE_ORIGINAL_BASE_URL
      : MEDIA_STORAGE_ORIGINAL_BASE_URL,
    `/${imageKey}`
  );

export const createRequireSrcSet = (...urls: string[]) =>
    urls.map((url, index) => `${require(url)} ${index + 1}x`).join(', ');

export const createLunResizedImageUrl = (
  imageKey: string,
  width: number,
  height: number
) => {
  return `https://market-images.lunstatic.net/lun-ua/${width}/${height}/images/${imageKey}.webp`;
};
